import { useCallback, useEffect, useState } from 'react';
// Display order is the order operators see in the table — also matches the
// order the show/hide dropdown lists toggles in.
export const COLUMNS = [
    { id: 'status', label: 'Status', defaultVisible: true },
    { id: 'chargebackPsp', label: 'Chargeback PSP', defaultVisible: true },
    { id: 'originalPsp', label: 'Original PSP', defaultVisible: true },
    { id: 'amount', label: 'Amount', defaultVisible: true },
    { id: 'defenseEndDate', label: 'Defense End Date', defaultVisible: true },
    { id: 'reasonCode', label: 'Reason Code', defaultVisible: true },
    { id: 'reason', label: 'Reason', defaultVisible: true },
    { id: 'propertyId', label: 'Property ID', defaultVisible: true },
    { id: 'reservationId', label: 'Reservation ID', defaultVisible: true }
];
const STORAGE_KEY = 'chargeback-dashboard.visible-columns.v1';
const defaultVisibleIds = () => COLUMNS.filter(c => c.defaultVisible).map(c => c.id);
const isColumnId = (value) => typeof value === 'string' && COLUMNS.some(c => c.id === value);
const readStorage = () => {
    if (typeof window === 'undefined') {
        return defaultVisibleIds();
    }
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) {
            return defaultVisibleIds();
        }
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) {
            return defaultVisibleIds();
        }
        return parsed.filter(isColumnId);
    }
    catch {
        return defaultVisibleIds();
    }
};
const writeStorage = (ids) => {
    if (typeof window === 'undefined') {
        return;
    }
    try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    }
    catch {
        // localStorage may be unavailable (private mode, etc.) — fall through; the
        // in-memory state still drives the current session.
    }
};
export const useVisibleColumns = () => {
    const [ids, setIds] = useState(readStorage);
    useEffect(() => {
        writeStorage(ids);
    }, [ids]);
    const toggle = useCallback((id) => {
        setIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
    }, []);
    const visible = new Set(ids);
    const isVisible = (id) => visible.has(id);
    return { visible, toggle, isVisible };
};
